import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
import store from '@/store';

Vue.use(VueRouter);
Vue.use(VueMeta);

import routes from './routes';

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    },
    linkExactActiveClass: 'nav-item active'
});

let isAuthInitialized = false;

/**
 * Async Pipeline Runner
 * Sequential middleware execution that supports async/await functions
 */
async function runMiddlewarePipeline(context, middleware, index) {
    const currentMiddleware = middleware[index];

    if (!currentMiddleware) {
        return context.next();
    }

    // Pass an interceptor 'next' function to the current middleware
    await currentMiddleware({
        ...context,
        next: async (nextArg) => {
            // If middleware passed a redirect or false to next(), break chain immediately
            if (nextArg !== undefined) {
                return context.next(nextArg);
            }
            // Move to the next middleware in the pipeline
            await runMiddlewarePipeline(context, middleware, index + 1);
        }
    });
}

router.beforeEach(async (to, from, next) => {
    // 2. Hydrate session on initial page load / refresh BEFORE running any middleware
    if (!isAuthInitialized) {
        await store.dispatch('auth/initializeAuth');
        isAuthInitialized = true;
    }

    // 3. Execute custom route middleware if present
    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware)
            ? to.meta.middleware
            : [to.meta.middleware];

        const context = { from, next, to, router, store };

        return await runMiddlewarePipeline(context, middleware, 0);
    }

    return next();
});

export default router;